import { monthFormat } from '@/filters'
import { setCheckButtons, setTableButtons } from '@/utils/getbuttons.js'
import { getSameAttribute } from '../handleData'
import {
  getLaborParentBidUid,
  isLaborCompanyOrg
} from '@/utils/bidLevelActions.js'
const salaryPay = {
  pageTabs: [
    {
      label: '薪酬统计',
      theme: 'salaryPay',
      step: 'payrollList',
      stepLabel: '工资单列表',
      checkFun: 'user/getSystemOrganUser'
    }
  ],
  payroll: {
    name: 'payroll',
    componentTypes: [
      'navigate',
      'pageTabs',
      'check',
      'tables',
      'dialogTable',
      'dialogForm'
    ], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    tagType: (params) => {
      if (params.getTagData) {
        const monthTime =
          params.queryValues && params.queryValues.monthTime
            ? params.queryValues.monthTime
            : monthFormat(new Date())
        return params.getTagData(monthTime, params.step).tagType
      }
    },
    tagInfo: (params) => {
      if (params.getTagData) {
        const monthTime =
          params.queryValues && params.queryValues.monthTime
            ? params.queryValues.monthTime
            : monthFormat(new Date())
        return params.getTagData(monthTime, params.step).tagInfo
      }
    },
    getListFun: 'salaryPay/getPayrolls',
    confirmFun: 'salaryPay/confirmPayroll',
    detailPage: [
      {
        buttonName: '详情',
        type: 'tables',
        name: 'payslip',
        step: 'payslipList',
        theme: 'salaryPay',
        label: '工资条列表',
        checkType: 'checkByRow',
        checkFun: 'salaryPay/getPayslips'
      },
    ],
    queryParams: {
      upVproUid: (params) => {
        if (params.orgType === 'simPro') return params.orgValue
        if (isLaborCompanyOrg(params.orgType)) {
          return getLaborParentBidUid(params) || ''
        }
        return ''
      },
      downVproUid: (params) => {
        return isLaborCompanyOrg(params.orgType) ? params.orgValue : ''
      },
      monthTime: monthFormat(new Date())
    },
    selectData: (params) => {
      const fields = []
      if (!isLaborCompanyOrg(params.orgType)) {
        fields.push(
          {
            key: 'upVproUid',
            label: '项目/标段',
            type: 'select',
            options: (item) => {
              return item.state.bidSection.subBidSection
            },
            checkByValue: true
          },
          {
            key: 'downVproUid',
            label: '劳务公司',
            type: 'select',
            placeholder: '请先选择项目标段后再选择',
            options: (item) => {
              return item.state.bidSection.laborCompanyNames
            },
            filterable: true,
            checkByValue: true
          }
        )
      }
      fields.push({
        key: 'monthTime',
        label: '统计月份',
        type: 'time',
        timetype: 'month',
        format: 'yyyy-MM',
        clearable: false
      })
      return fields
    },
    rowData: (params) => {
      return params.state.salaryPay.payrollList.result
    },
    rowTotal: (params) => {
      return params.state.salaryPay.payrollList.totalSize
    },
    rowKey: 'laborTeamUid',
    columns: [
      { prop: 'laborTeamName', label: '劳务公司名称', width: '300px' },
      { prop: 'period', label: '发放月份', width: '' },
      { prop: 'currentShouldPay', label: '应发月薪', width: '' },
      { prop: 'currentOwePay', label: '本月暂扣', width: '' },
      { prop: 'currentActualPay', label: '实发月薪', width: '' },
      { prop: 'replacePay', label: '本月补发', width: '' },
      { prop: 'actualPay', label: '本月实发', width: '' },
      { prop: 'cumuOwePay', label: '累计欠发', width: '' },
      { prop: 'total', label: '累计发放率', width: '' },
      { prop: 'settlementProgress', label: '结算进度', width: '' },
      { prop: 'confirmProgress', label: '确认进度', width: '' },
      {
        label: '操作',
        buttons: setTableButtons(['详情', '确认']),
        width: '200px'
      }
    ],
    hasPagination: true,
  },
  payslip: {
    name: 'payslip',
    componentTypes: [
      'navigate',
      'check',
      'tables',
      'dialogTable',
      'dialogForm'
    ], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    tagType: (params) => {
      if (params.getTagData && params.queryValues) {
        const monthTime = params.queryValues.monthTime
        const laborCompanyName = params.queryValues.laborCompanyName
        return params.getTagData(monthTime, params.step, laborCompanyName)
          .tagType
      }
    },
    tagInfo: (params) => {
      if (params.getTagData && params.queryValues) {
        const monthTime = params.queryValues.monthTime
        const laborCompanyName = params.queryValues.laborCompanyName
        return params.getTagData(monthTime, params.step, laborCompanyName)
          .tagInfo
      }
    },
    getListFun: 'salaryPay/getPayslips',
    confirmFun: 'salaryPay/confirmPayroll',
    detailPage: [
      {
        buttonName: '批量结算',
        type: 'dialogForm',
        name: 'settlement'
      },
      {
        buttonNames: ['结算', '查看', '修改'],
        type: 'dialogForm',
        name: 'settlement',
        checkType: 'checkByRow',
        checkFun: 'salaryPay/getPayslip'
      },
      {
        buttonName: '导入薪酬',
        type: 'dialogTable',
        name: 'upLoadPayslips'
      }
    ],
    headButtons: (params) => {
      if (
        params.queryValues &&
        params.orgValue === params.queryValues.upVproUid
      ) {
        return setCheckButtons([
          '批量结算',
          '确认薪酬',
          '导入薪酬',
          '下载导入模板'
        ])
      } else {
        return []
      }
    },
    selectColumn: true,
    queryParams: {
      upVproUid: (params) => {
        return params.queryValues.upVproUid
      },
      downVproUid: (params) => {
        return params.queryValues.downVproUid
      },
      laborCompanyName: (params) => {
        return params.queryValues.laborCompanyName
      },
      monthTime: (params) => {
        return params.queryValues.monthTime
      },
      teamUid: '',
      personName: ''
    },
    selectData: [
      {
        key: 'teamUid',
        label: '作业班组',
        type: 'select',
        options: (params) => {
          return params.state.contractor.teamNames
        },
        checkByValue: true
      },
      {
        key: 'personName',
        label: '关键词',
        type: 'input',
        placeholder: '姓名'
      }
    ],
    rowData: (params) => {
      return params.state.salaryPay.payslipList.result
    },
    rowTotal: (params) => {
      return params.state.salaryPay.payslipList.totalSize
    },
    columns: [
      {
        prop: 'nameDisplay',
        label: '姓名',
        width: '160px',
        badgeListKey: 'nameBadges'
      },
      { prop: 'attendanceDays', label: '出勤', width: '80px' },
      { prop: 'contractEffectiveTime', label: '结算方式', width: '' },
      { prop: 'calculateNum', label: '计量数量', width: '' },
      { prop: 'priceUnit', label: '单价', width: '' },
      { prop: 'overtimePay', label: '加班工资', width: '' },
      { prop: 'grossPay', label: '税前工资', width: '' },
      { prop: 'cutPayment', label: '税金及扣款', width: '' },
      { prop: 'currentShouldPay', label: '应发月薪', width: '' },
      { prop: 'currentOwePay', label: '本月暂扣', width: '' },
      { prop: 'currentActualPay', label: '实发月薪', width: '' },
      { prop: 'replacePay', label: '本月补发', width: '' },
      { prop: 'actualPay', label: '本月实发', width: '' },
      {
        prop: 'payStatus',
        label: '状态',
        width: '120px',
        tag: [
          { type: 'success', label: '薪酬已确认' },
          { type: 'danger', label: '已结算，被拒绝' },
          { type: 'warning', label: '已结算，待确认' }
        ],
        tooltip: (row) => {
          if (!row || row.payStatus !== '已结算，被拒绝') return null
          const tip =
            row.refuseMark ||
            row.refuse_mark ||
            row.agreeType ||
            row.agree_type ||
            ''
          const text = String(tip || '')
            .trim()
            .replace(/^个人拒绝[:：]?/, '')
          if (!text) return null
          return {
            tipLabel: '拒绝意见：',
            tipValue: text
          }
        }
      },
      {
        label: '操作',
        buttons: setTableButtons(['查看', '结算', '修改']),
        width: '220px'
      }
    ],
    hasPagination: true,
    settlement: {
      name: 'settlement',
      title: '工资条明细信息',
      addFun: 'salaryPay/addPayslip',
      editFun: 'salaryPay/editPayslip',
      batchSettleFun: 'salaryPay/batchAddPayslip',
      getParentFun: 'salaryPay/getPayslips',
      formParams: {
        uid: '',
        personNames: (params) => {
          return params.state.selection.payslip
            ? getSameAttribute(
                params.state.selection.payslip.map((row) => {
                  return Object.assign({}, row, {
                    name: row.nameDisplay || row.name
                  })
                }),
                'name',
                '、'
              ).joinString
            : ''
        },
        vProjectUid: '',
        laborTeamUid: '',
        teamNameUid: '',
        personUid: '',
        // 出勤默认取工资条/考勤实际天数，禁止默认整月天数（会与考勤对不上）
        attendanceDays: 0,
        contractEffectiveTime: '计件',
        calculateNum: 0,
        calculateUnit: '',
        priceUnit: 0,
        overtimePay: 0,
        grossPay: 0,
        cutPayment: 0,
        currentShouldPay: 0,
        currentOwePay: 0,
        currentActualPay: 0,
        withholdReason: '',
        replacePay: 0,
        cumuShouldPay: 0,
        cumuOwePay: 0,
        cumuActualPay: 0,
        period: (params) => {
          return params.state.queryValues.payslip.monthTime
        },
        pEntryUid: ''
      },
      formRules: (params) => {
        var formRules = {
          overtimePay: [
            {
              required: true,
              message: '请输入加班工资',
              trigger: 'blur'
            }
          ],
          cutPayment: [
            {
              required: true,
              message: '请输入税金及扣款',
              trigger: 'blur'
            }
          ],
          currentOwePay: [
            {
              required: true,
              message: '请输入本月暂扣金额',
              trigger: 'blur'
            }
          ],
          replacePay: [
            {
              required: true,
              message: '请输入本月补发金额',
              trigger: 'blur'
            },
            {
              validator: (params) => {
                return (rule, value, callback) => {
                  if (value === '' || value === null || value === undefined) {
                    callback()
                    return
                  }
                  const num = Number(value)
                  if (isNaN(num) || num < 0) {
                    callback(new Error('本月补发不能为负数'))
                    return
                  }
                  const payslip =
                    (params.state.salaryPay && params.state.salaryPay.payslip) ||
                    {}
                  const max =
                    payslip.maxReplacePay != null
                      ? Number(payslip.maxReplacePay)
                      : NaN
                  if (!isNaN(max) && num > max) {
                    callback(
                      new Error(
                        '本月补发不能大于进入本月前累计欠发（可补发上限 ' +
                          max +
                          ' 元）'
                      )
                    )
                    return
                  }
                  callback()
                }
              },
              trigger: 'blur'
            }
          ]
        }
        // 批量结算出勤按考勤表独立取值，弹窗不再填报，无需校验
        if (params.pageStatus !== 'batch') {
          formRules.attendanceDays = [
            {
              required: true,
              message: '请输入出勤天数',
              trigger: 'blur'
            }
          ]
        }
        return formRules
      },
      formData: (params) => {
        var formData = [
          {
            key: 'personNames',
            isShow: params.pageStatus === 'batch',
            label: '人员姓名',
            type: 'input',
            inputType: 'textarea',
            autosize: true,
            disabled: true,
            span: 24
          },
          {
            isShow: params.pageStatus === 'batch',
            type: 'tag',
            span: 24,
            tag: '出勤天数按考勤表独立计算；所选人员加班工资、税金及扣款、本月暂扣、本月补发等信息应一致，否则请分批结算。本月补发不能超过各人进入本月前累计欠发'
          },
          {
            isShow:
              params.pageStatus !== 'batch' && params.pageStatus !== 'check',
            type: 'tag',
            span: 24,
            tag: (params) => {
              const payslip =
                (params.state.salaryPay && params.state.salaryPay.payslip) || {}
              const max =
                payslip.maxReplacePay != null ? payslip.maxReplacePay : 0
              return (
                '本月补发不能超过进入本月前累计欠发，当前可补发上限 ' +
                max +
                ' 元'
              )
            }
          },
          {
            key: 'personName',
            isShow: params.pageStatus !== 'batch',
            label: '人员姓名',
            type: 'input',
            disabled: true
          },
          {
            key: 'cardNum',
            isShow: params.pageStatus !== 'batch',
            label: '银行卡号',
            type: 'input',
            disabled: true
          },
          {
            key: 'period',
            label: '发放月份',
            type: 'input',
            disabled: true
          },
          {
            key: 'attendanceDays',
            isShow: params.pageStatus !== 'batch',
            label: '出勤天数',
            type: 'input',
            inputButton: '天',
            disabled: params.pageStatus === 'check',
            number: true
          },
          {
            key: 'contractEffectiveTime',
            isShow: params.pageStatus !== 'batch',
            label: '结算方式',
            type: 'input',
            disabled: true
          },
          {
            key: 'calculateNum',
            isShow: params.pageStatus !== 'batch',
            label: '计量数量',
            type: 'input',
            disabled: true
          },
          {
            key: 'calculateUnit',
            isShow: params.pageStatus !== 'batch',
            label: '计量单位',
            type: 'input',
            disabled: true
          },
          {
            key: 'priceUnit',
            isShow: params.pageStatus !== 'batch',
            label: '计量单价',
            type: 'input',
            disabled: true,
            inputButton: '元'
          },
          {
            key: 'overtimePay',
            label: '加班工资',
            type: 'input',
            disabled: params.pageStatus === 'check',
            number: 2,
            inputButton: '元'
          },
          {
            key: 'grossPay',
            isShow: params.pageStatus !== 'batch',
            label: '税前工资',
            type: 'input',
            disabled: true,
            inputButton: '元'
          },
          {
            key: 'cutPayment',
            label: '税金及扣款',
            type: 'input',
            disabled: params.pageStatus === 'check',
            number: 2,
            inputButton: '元'
          },
          {
            key: 'currentShouldPay',
            isShow: params.pageStatus !== 'batch',
            label: '应发月薪',
            type: 'input',
            disabled: true,
            inputButton: '元'
          },
          {
            key: 'currentOwePay',
            label: '本月暂扣',
            type: 'input',
            disabled: params.pageStatus === 'check',
            number: 2,
            inputButton: '元'
          },
          {
            key: 'replacePay',
            label: '本月补发',
            type: 'input',
            disabled: params.pageStatus === 'check',
            number: 2,
            inputButton: '元'
          },
          {
            key: 'actualPay',
            isShow: params.pageStatus !== 'batch',
            label: '本月实发',
            type: 'input',
            disabled: true,
            inputButton: '元'
          },
          {
            key: 'cumuShouldPay',
            isShow: params.pageStatus !== 'batch',
            label: '累计应发',
            type: 'input',
            disabled: true,
            inputButton: '元'
          },
          {
            key: 'cumuActualPay',
            isShow: params.pageStatus !== 'batch',
            label: '累计实发',
            type: 'input',
            disabled: true,
            inputButton: '元'
          },
          {
            key: 'cumuOwePay',
            isShow: params.pageStatus !== 'batch',
            label: '累计欠发',
            type: 'input',
            disabled: true,
            inputButton: '元'
          },
          {
            key: 'withholdReason',
            label: '扣款原因',
            type: 'input',
            placeholder:
              '当税金及扣款或本月暂扣不为0元时，请输入对应的扣款项原因',
            inputType: 'textarea',
            autosize: true,
            disabled: params.pageStatus === 'check',
            span: 24
          }
        ]
        return formData
      },
      hasFooter: (params) => {
        return params.pageStatus !== 'check'
      }
    },
    upLoadPayslips: {
      dialogTitle: '导入薪酬',
      title: '薪酬列表',
      name: 'upLoadPayslips',
      height: '570px',
      upload: true,
      rowKey: 'index',
      upLoadFun: 'salaryPay/upLoadPayslips',
      getParentFun: 'salaryPay/getPayslips',
      rowButtons: setTableButtons(['删除']),
      columns: [
        { prop: 'name', label: '人员姓名', width: '' },
        { prop: 'attendanceDays', label: '出勤天数', width: '' },
        { prop: 'currentShouldPay', label: '应发月薪', width: '' },
        { prop: 'currentActualPay', label: '实发月薪', width: '' },
        { prop: 'replacePay', label: '本月补发', width: '' },
        { prop: 'status', label: '数据状态', width: '150px' },
        {
          label: '操作',
          buttons: setTableButtons(['删除'])
        }
      ]
    }
  }
}

export default salaryPay
